<template>
  <div class="therapy-choices">
    <a
      class="lavendla-link-box__wrapper use-alternative-layout lavendla-link-box__use-icon-color"
      rel="noopener noreferrer"
      target="_blank"
      v-for="(choice, index) in choices"
      :key="choice.heading"
      :data-cy="`therapy-choice-${index}`"
      :href="choice.url"
    >
      <img alt="" aria-hidden="true" v-if="choice.image" :src="choice.image" />
      <span class="lavendla-link-box__content-wrapper">
        <span class="lavendla-link-box__content">
          <span class="lavendla-link-box__heading" v-text="choice.heading" />
          <span
            class="lavendla-link-box__text"
            v-if="choice.text"
            v-text="choice.text"
          />
          <svg class="icon lavendla-link-box__arrow">
            <use href="#arrow-right-long" />
          </svg>
        </span>
      </span>
    </a>
  </div>
</template>

<script>
export default {

  computed: {
    choices() {
      return window?.theme_vars?.contactTexts?.contactFormChoicesTherapy;
    },
  },
  name: 'TherapyChoices',
};
</script>
